export default {
  name: 'Bier',
  isRotated: true,
  versions: [
    'bier/bier_1.jpg',
    'bier/bier_2.jpg',
    'bier/bier_3.jpg'
  ],
  containerStyle: {
    paddingBottom: '15%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: 'Arial',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1',
    marginTop: '5px',
    marginBottom: '5px',
    fontWeight: 'bold',
    textShadow:
      '0px 0px 20px rgba(0,0,0,1)',
    hyphens: 'auto'
  },
  customStyles: [
    {
      name: "weiss",
      style: {
        color: '#FFFFFF',
      }
    },
  ],
  customContainerStyles: [
    {
      name: 'bier/bier_2.jpg',
      style: {
        transform: 'rotate(-4deg)',
        paddingBottom: '12%',
      }
    },
    {
      name: 'bier/bier_3.jpg',
      style: {
        paddingBottom: '105%',
      }
    }
  ],
  linesDefault: [
    {
      text: 'Verpflichtendes Wegbier in der U-Bahn!',
      style: 0,
      fontSize: 60
    }
]
}



// WEBPACK FOOTER //
// ./src/config/bier.js